import styled from '@emotion/styled';

import { baseText } from '@zego/theme';

const RegularText = styled.p(baseText, { margin: 0, padding: 0 });

export default RegularText;
